import { BaseRouteService } from "core/services";

class TrackingCaseRouteService extends BaseRouteService {
	constructor() {
		super("tracking-cases");	
	}	
	
	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,facilityId,patientId,itemCategoryId,caseStatusId,patientPatientId}`, filter);
	}	
	
	get(id, options) {		
		return super.get(`${this.base}/{id}{?embed,fields}`, id, options);	
	}	
	
	create(resource) {		
		return super.create(this.base, resource);	
	}

	update(resource) {
		return super.update(`${this.base}/{id}`, resource);	
	}	
	
	delete(resource) {		
		return super.delete(`${this.base}/{id}`, resource);	
	}

	copy(resource) {
        return super.create(`${this.base}/copy/{id}`, resource);
    }
}

export default TrackingCaseRouteService;